var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26.5","cy":"26.5","r":"24.5","fill":"#0A9E50","stroke":"#E1E8EC","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M32.77 25.0854L27.6083 30.2471C26.9987 30.8567 26.0012 30.8567 25.3916 30.2471L20.23 25.0854","stroke":"white","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowDownInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 53 53","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
